/**
 * [analityka1005, poprawka po przeglądzie] ZNACZNIK „CZŁOWIEK / TŁO” DLA DZIENNIKA AKTYWNOŚCI mPRACOWNIKA.
 *
 * Co było źle: serwer zgadywał po samej ścieżce, czy żądanie to praca. Każde GET spoza krótkiej listy odpytań było
 * „otwarciem strony”, a otwarta karta sama wysyła żądania co 1–2 minuty (plakietka wniosków w menu, tryb nagrania,
 * pasek komunikatów, czat Teams, odświeżenia po zdarzeniach z serwera). Karta zostawiona na 8 godzin dawała
 * 8 godzin „czasu pracy w mPracowniku” — choć ekran obiecywał czas „bez ruchu w tle”.
 *
 * Jak jest: to PRZEGLĄDARKA wie, czy żądanie wysłał człowiek. Każde żądanie przez `apiService` dostaje nagłówek
 * `X-Aktywnosc`:
 *   • „czlowiek” — karta jest widoczna i od ostatniego działania człowieka (kliknięcie, klawisz, przewinięcie,
 *     dotknięcie, upuszczenie, wybór pliku, wstecz/dalej) minęło najwyżej 10 sekund; otwarcie strony też jest działaniem;
 *   • „tlo” — w każdym innym przypadku (zegar w otwartej karcie, karta ukryta, odświeżenie po zdarzeniu z serwera).
 * Serwer (ActivityKindClassifier.Klasyfikuj) liczy jako pracę tylko żądania „czlowiek” i zapisy; żądanie bez nagłówka
 * (stara karta sprzed wdrożenia, obrazek) pracą nie jest.
 *
 * 10 sekund: żądania po kliknięciu wychodzą zwykle w ułamku sekundy; zapas jest na wolne łącze i doczytanie kodu strony.
 * Zegar, który odpali w tym oknie, policzy się jako praca — ale wtedy człowiek i tak pracował w tych samych 5 minutach.
 */
export const NAGLOWEK_AKTYWNOSCI = "X-Aktywnosc";
export const CZLOWIEK = "czlowiek";
export const TLO = "tlo";
export const OKNO_PO_DZIALANIU_MS = 10_000;

/** Zdarzenia okna, które są działaniem człowieka (ruch samej myszy nim nie jest). */
export const ZDARZENIA_CZLOWIEKA = ["pointerdown", "pointerup", "keydown", "wheel", "touchstart", "drop", "change", "popstate"];

let ostatnieDzialanieMs = null;
let nasluchPodpiety = false;

/** Zapamiętuje chwilę działania człowieka (ms od epoki). */
export const odnotujDzialanie = (kiedyMs = Date.now()) => { ostatnieDzialanieMs = kiedyMs; };

const kartaWidoczna = () => typeof document === "undefined" || document.visibilityState !== "hidden";

/** Podpina nasłuch działań człowieka (raz). Otwarcie strony liczy się jako pierwsze działanie. */
export const podepnijNasluchDzialan = (okno = typeof window !== "undefined" ? window : null) => {
    if (!okno || nasluchPodpiety) return;
    nasluchPodpiety = true;
    odnotujDzialanie();
    ZDARZENIA_CZLOWIEKA.forEach((nazwa) => {
        okno.addEventListener(nazwa, () => odnotujDzialanie(), { capture: true, passive: true });
    });
};

/**
 * „czlowiek” albo „tlo” dla żądania wysyłanego w chwili `kiedyMs`.
 * `wTle: true` — wywołujący sam wie, że to żądanie zegarowe (zawsze „tlo”).
 */
export const znacznikAktywnosci = ({ kiedyMs = Date.now(), widoczna = kartaWidoczna(), wTle = false } = {}) => {
    if (wTle || !widoczna || ostatnieDzialanieMs === null) return TLO;
    const odDzialania = kiedyMs - ostatnieDzialanieMs;
    return odDzialania >= 0 && odDzialania <= OKNO_PO_DZIALANIU_MS ? CZLOWIEK : TLO;
};

/** Dopisuje nagłówek do konfiguracji żądania axios. Telemetria nigdy nie może zepsuć żądania. */
export const oznaczZadanie = (config) => {
    try {
        podepnijNasluchDzialan();
        if (config && config.headers) config.headers[NAGLOWEK_AKTYWNOSCI] = znacznikAktywnosci({ wTle: config.wTle === true });
    } catch {
        /* celowo pusto */
    }
    return config;
};

podepnijNasluchDzialan();
